export enum Paths {
  COMPARE = "/compare",
  CREATE_ACCOUNT = "/",
  SIGN_IN = "/signin",
  SUBMIT_ANSWERS = "/submit",
}
